import { css } from "styled-components";

export const getButtonTextAlignment = ({ cardContentAlignment }) => {
    /* this helper is for taking alignments meant for text-align and mapping
       them to the justify-content (flexbox) equivalent since it was the only
       way to get this to work with the way core/Button is set up. */
    switch (cardContentAlignment) {
        case "left":
            return css`
                justify-content: flex-start;
            `;
        case "justify":
            return css`
                justify-content: flex-start;
            `;
        case "center":
            return css`
                justify-content: center;
            `;
        case "right":
            return css`
                justify-content: flex-end;
            `;
        default:
            return css`
                justify-content: center;
            `;
    }
};
